export const handleSwipe = {
    data() {
        return {

        }
    },
    methods: {
        handleSwipe(el, handlerRight, handlerLeft, unbind=false) {
            const handleTouch = (start, end) => {
                if (start > end && start - end > 50) {
                    handlerRight();
                } else if (start < end && end - start > 50) {
                    handlerLeft();
                }
            }
            let startX, endX;
            const touchStartHandler = (e) => {
                startX = e.touches[0].clientX;
            }
            const touchEndHandler = (e) => {
                endX = e.changedTouches[0].clientX;
                handleTouch(startX, endX);
            }
            if (unbind) {
                el.removeEventListener('touchstart', touchStartHandler, false);
                el.removeEventListener('touchend', touchEndHandler, false);
            } else {
                el.addEventListener('touchstart', touchStartHandler, false);
                el.addEventListener('touchend', touchEndHandler, false);
            }
            
        }
    }
}
